import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ProductPhotoModalComponent } from '../dialogs/product-photo-modal/product-photo-modal.component';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HostListener } from "@angular/core";
import { SpinnerOverlayComponent } from '../dialogs/spinner-overlay/spinner-overlay.component';
import { MatStepper } from '@angular/material/stepper';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';
import { restoreFocus } from '@syncfusion/ej2-grids';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.sass'],
})
export class ShoppingCartComponent implements OnInit {

  screenWidth: any;
  screenHeight: any;
  mobileView: boolean;
  smallFooter: boolean = true;
  currentStep: any = 0;

  disable_purchase: boolean = false

  firstFormGroup: FormGroup;
  personalInformationForm: FormGroup;
  shippingInformationForm: FormGroup;
  displayedColumns: string[] = ['photo-summary', 'product', 'description', 'unit_pvp', 'quantity' /*, 'pvp'*/];
  products: any;
  productDescriptions: any = {};
  productQuantityOverview: any[] = [];
  dataSource = new MatTableDataSource<any>();
  numberList: any[];
  showPrimarySpinner: boolean = true;
  hasShipping: boolean = false;
  no_shipping_txt_es: string;
  no_shipping_txt_en: string;
  no_shipping_txt_cat: string;
  totalAmount: number = 0;
  subtotal: number = 0;
  value_shipping: number = 0;
  shipping_tax: number = 0;
  num_products: number = 0;

  constructor(
    private router: Router,
    private dataService: DataService,
    public firebase: AngularFireAuth,
    public dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private snackbar: MatSnackBar,
    private translate: TranslateService,
  ) {
    this.numberList = Array(10).fill(1).map((x, i) => i + 1);

    this.getScreenSize();

  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth >= 1150) {

      this.mobileView = false

    } else {

      this.mobileView = true

    }

  }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      // firstCtrl: ['', Validators.required]
    });

    this.personalInformationForm = this._formBuilder.group({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      id_num: new FormControl('', Validators.required),
      tel_num: new FormControl('', Validators.required),
      accept_conditions: new FormControl(false)
    })

    this.shippingInformationForm = this._formBuilder.group({
      address: new FormControl('', Validators.required),
      postal_code: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required)
    })


    let dialogRef = this.dialog.open(SpinnerOverlayComponent, {
      panelClass: 'transparent',
      disableClose: true
    })

    this.firebase.user.subscribe(user => {

      if (user) {
        this.totalAmount = 0;
        this.dataService.getShoppingCart().subscribe(response => {

          console.log(response)
          // CREATES ITEM LIST WITH ALBUM ITEMS GROUPED TOGETHER
          let r = this.createItemList(response);

          this.products = response;
          this.dataSource.data = r;
          // this.dataSource.data = this.products;

          this.products.forEach(element => {
            // this.totalAmount += element.total_line;
            let description = JSON.parse(element.description)
            this.productDescriptions[element.id] = description;

            this.productQuantityOverview.push({ 'id': element.id, 'unit': 0, 'name_en': element.name_en, 'name_es': element.name_es, 'name_cat': element.name_cat, 'value': element.value })
          });

          this.dataService.getTotalShoppingCart(true).subscribe(res => {
            

            if (res.status == "ok") {

              this.subtotal = res.total_price
              this.value_shipping = res.value_shipping
              this.shipping_tax = res.shipping_tax
              this.totalAmount = res.hasShipping ? Number(res.total_price) + Number(res.value_shipping) : Number(res.total_price)
              this.hasShipping = res.hasShipping
              this.no_shipping_txt_es = res.no_shipping_txt_es
              this.no_shipping_txt_en = res.no_shipping_txt_en
              this.no_shipping_txt_cat = res.no_shipping_txt_cat
              this.showPrimarySpinner = false
              this.num_products = res.total_products
              this.disable_purchase = res.deactivate_purchase
            }

            this.smallFooter = false;
            dialogRef.close()

          })
          // Hide primary spinner once student content is loaded
        })

      } else {
        this.showPrimarySpinner = false // Hide primary spinner once student content is loaded
        dialogRef.close()
        this.router.navigate(['/login']);
      }
    })
  }


  private createItemList(response: any) {
    let r = [];
    let names = {};
    response.forEach(item => {
      if (!item.album_id) {
        r.push(item);
      } else {
        let y = r.find(o => o.album_id === item.album_id);
        if (!r.find(o => o.album_id === item.album_id)) {
          names[item.album_id] = [item['name']]
          let name = {}
          name[item.album_id] = [item['name']]
          item['name'] = name
          r.push(item);
        } else {
          names[item.album_id].push(item['name'])
          r.forEach(i => {
            if(item.album_id == i.album_id){
              i['quantity'] = item.quantity
              i['value'] += item.value;
              i['total_line'] += item.total_line;
              if (i['url1'] == '') { i['url1'] = item.url1; }
              i['name'] = names;
            }
          });
        }
      }
    });
    return r;
  }

  paymentTPV(infoForm: FormGroup, addressForm: FormGroup = null, bizum: boolean = false) {

    if (this.disable_purchase) {
      this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.no_orders'), duration: 4000, panelClass: "error-snackbar" })
      return
    }
    

    this.showErrorSnackbar(infoForm);
    if (infoForm.value.accept_conditions != true) {

      this.translate.get('alerts.conditions_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })


      return false;
    }

    let dialogRef = this.dialog.open(SpinnerOverlayComponent, {
      panelClass: 'transparent',
      disableClose: true
    })

    let params = {}
    params['name'] = infoForm.value.name
    params['surname'] = infoForm.value.surname
    params['dni'] = infoForm.value.id_num
    params['phone'] = infoForm.value.tel_num

    if (addressForm) {
      params['address'] = addressForm.value.address
      params['postal_code'] = addressForm.value.postal_code
      params['city'] = addressForm.value.city
      params['country'] = addressForm.value.country
    }

    if(bizum)
    {
      params['payment_method'] = 'bizum'
    }

    // TODO Include above params in api call below

    this.dataService.proceedToPaymentTPV(params).subscribe(res => {
      
      let ds_signatureVersion = res.Ds_SignatureVersion
      let ds_signature = res.Ds_Signature
      let ds_merchantParams = res.Ds_MerchantParameters


      const paymentLinkForm = document.createElement('form');
      paymentLinkForm.method = 'POST';
      // paymentLinkForm.action = 'https://sis-t.redsys.es:25443/sis/realizarPago'; //TEST
      paymentLinkForm.action = 'https://sis.redsys.es/sis/realizarPago'; //REAL
      paymentLinkForm.style.display = 'none';
      paymentLinkForm.append('Content-Type', 'application/x-www-form-urlencoded');

      const ds_signatureVersionInput = document.createElement('input');
      ds_signatureVersionInput.type = 'hidden';
      ds_signatureVersionInput.name = 'Ds_SignatureVersion';
      ds_signatureVersionInput.value = ds_signatureVersion;
      paymentLinkForm.appendChild(ds_signatureVersionInput);

      const ds_merchantParamsInput = document.createElement('input');
      ds_merchantParamsInput.type = 'hidden';
      ds_merchantParamsInput.name = 'Ds_MerchantParameters';
      ds_merchantParamsInput.value = ds_merchantParams;
      paymentLinkForm.appendChild(ds_merchantParamsInput);

      const ds_signatureInput = document.createElement('input');
      ds_signatureInput.type = 'hidden';
      ds_signatureInput.name = 'Ds_Signature';
      ds_signatureInput.value = ds_signature;
      paymentLinkForm.appendChild(ds_signatureInput);

      dialogRef.close();

      document.body.appendChild(paymentLinkForm);

      paymentLinkForm.submit();

    })


  }

  showErrorSnackbar(form: FormGroup) {

    if (!form.valid) {

      this.translate.get('alerts.form_error').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })

      throw new Error('Invalid or missing form data')

    }

  }

  openPhotoPreview(image_url: string) {

    let dialogRef = this.dialog.open(ProductPhotoModalComponent, {
      maxWidth: '1000px',
      width: '92%',
      backdropClass: 'photo-dialog-backdrop',
      panelClass: 'photo-dialog',
      data: image_url
    })
  }

  updateAlbumQuantity(quantity: number, album_id: any, product_id: number){
    let dialogRef = this.dialog.open(SpinnerOverlayComponent, {
      panelClass: 'transparent',
      disableClose: true
    })
    let params = {
      "quantity": quantity,
      "album_id": album_id,
      "products": [],
      "product_id": product_id
    }
    this.products.forEach(element => {
      if(element.album_id==album_id){
        params['products'].push(element)
      }
    });
    this.dataService.updateAlbumQuantity(params).subscribe(res => {
      if(res.status!='success'){
        this.translate.get('alerts.generic_error_message').subscribe((msg: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: msg, duration: 4000, panelClass: "error-snackbar" })
          dialogRef.close();
        })
      } else {
        this.dataService.getShoppingCart().subscribe(response => {
          let r = this.createItemList(response)
          this.products = response;
          this.dataSource.data = r;
          // dialogRef.close();
        })
        this.dataService.getTotalShoppingCart(true).subscribe(res => {
          
          if (res.status == "ok") {

            this.subtotal = res.total_price
            this.value_shipping = res.value_shipping
            this.shipping_tax = res.shipping_tax
            this.totalAmount = res.hasShipping ? Number(res.total_price) + Number(res.value_shipping) : Number(res.total_price)
            this.hasShipping = res.hasShipping
            this.no_shipping_txt_es = res.no_shipping_txt_es
            this.no_shipping_txt_en = res.no_shipping_txt_en
            this.no_shipping_txt_cat = res.no_shipping_txt_cat
            this.showPrimarySpinner = false
            this.num_products = res.total_products
          }

          this.smallFooter = false;
          dialogRef.close()

        })


      }
    })

  }

  updateProductQuantity(quantity: number, productID: String, studentID: number, reportageID: number) {
    let params = {}
    params['productID'] = productID
    params['studentID'] = studentID
    params['reportageID'] = reportageID
    params['quantity'] = quantity
    let dialogRef = this.dialog.open(SpinnerOverlayComponent, {
      panelClass: 'transparent',
      disableClose: true
    })

    this.dataService.updateProductQuantity(params).subscribe(res => {
      if (res.status == 'ok') {
        if (quantity == 0) {
          this.dataService.getShoppingCart().subscribe(response => {
            let r = this.createItemList(response)
            this.products = response;
            this.dataSource.data = r;
          })
        }
        else {
          // Update quantity select
          this.products.forEach(element => {
            if (element.id == productID && element.photo_id == reportageID)  {
              if (element.student_id == studentID) {
                element['quantity'] = quantity
              }

            }
          });
        }

        this.dataService.getTotalShoppingCart(true).subscribe(res2 => {





          if (res2.status == "ok") {

            this.subtotal = res2.total_price
            this.value_shipping = res2.value_shipping
            this.shipping_tax = res2.shipping_tax
            this.totalAmount = res2.hasShipping ? Number(res2.total_price) + Number(res2.value_shipping) : Number(res2.total_price)
            this.hasShipping = res2.hasShipping
            this.no_shipping_txt_es = res2.no_shipping_txt_es
            this.no_shipping_txt_en = res2.no_shipping_txt_en
            this.no_shipping_txt_cat = res2.no_shipping_txt_cat
            this.showPrimarySpinner = false
            this.num_products = res2.total_products

            if (this.subtotal == 0) {
              this.value_shipping = 0;
              this.totalAmount = 0;

            }
          }

          this.smallFooter = false;
          dialogRef.close()

          // if (res2.status == "ok") {

          //   this.totalAmount = Number(res2.total_price) + this.value_shipping
          //   this.subtotal = res2.total_price
          //   this.num_products = res2.total_products

          //   if (this.subtotal == 0) {
          //     this.value_shipping = 0;
          //     this.totalAmount = 0;

          //   }
          // }

        })
      }
      else if (res.status == 'downloadable_max_1'){
        this.translate.get('buttons.dismiss').subscribe((res: string) => {

          let dismiss = res;

          this.translate.get('alerts.downloadable_max_1').subscribe((res: string) => {

            let msg = res;

            this.snackbar.open(msg, dismiss, { duration: 5000 ,panelClass: ['error-snackbar'] })

            this.smallFooter = false;
            dialogRef.close()

          })

        })
      }
    })
  }

  changeLang(lang: string) {
    localStorage.setItem('language', lang)
    this.dataService.changeLang(lang).subscribe(res => {
      if (res == 'updated') {
        this.translate.use(lang);
      }

    });

  }

  goTo(route: string) {

    this.router.navigate([route]);

  }

  goBack(stepper: MatStepper) {
    stepper.previous();
    this.currentStep = stepper.selectedIndex
  }

  goForward(stepper: MatStepper) {
    stepper.next();
    this.currentStep = stepper.selectedIndex
  }

}
